"use client";

import React from "react";

const OurVideos: React.FC = () => {
  return (
    <>
      <section className="relative w-full bg-gradient-to-br from-gray-50 to-white pt-32 pb-12 sm:pt-36 sm:pb-16 overflow-hidden">
        {/* Your decorative background elements */}

        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-8 lg:px-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 text-center after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:my-5 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)] mb-16">
            Educational Dental Videos
          </h1>

          <div className="space-y-16">
            {/* Hulu Ad */}
            <div className="max-w-5xl mx-auto">
              <div className="relative rounded-lg overflow-hidden border-[5px] border-transparent bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] p-[5px]">
                <div className="relative rounded-lg overflow-hidden bg-white">
                  <div className="relative aspect-video">
                    <iframe
                      src="https://www.youtube.com/embed/kh9TU7_bBD0"
                      title="smile4me Hulu Advertisement"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      className="absolute inset-0 w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Office Tour */}
            <div className="max-w-5xl mx-auto">
              <div className="relative rounded-lg overflow-hidden border-[5px] border-transparent bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] p-[5px]">
                <div className="relative rounded-lg overflow-hidden bg-white">
                  <div className="relative aspect-video">
                    <iframe
                      src="https://www.youtube.com/embed/EEMlluIhe5A"
                      title="smile4me Office Tour"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      className="absolute inset-0 w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurVideos;